<div class="form-group">

  <label [attr.for]="buildChildId()"
         [class.sr-only]="!label"
         [ngClass]="labelStyleModifier">
    {{label}}
  </label>

  <ng-content></ng-content>

  <input
    class="form-control"
    [name]="name || label"
    [attr.maxlength]="getMaxLength()"
    [attr.autocomplete]="autocomplete || 'off'"
    [attr.disabled]="disabled ? 'disabled' : null"
    [attr.id]="buildChildId()"
    [attr.placeholder]="placeholder || null"
    [attr.aria-required]="required || null"
    [ngModel]="model"
    (ngModelChange)="onModelChange($event)"
    (keydown)="onKeyDown($event)"
    (keyup)="onKeyUp($event)"
    #entryComponent
  />

  <achoo-validation-alerts [component]="this"></achoo-validation-alerts>

</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-material-input/achoo-material-input.component.html